module.exports = __webpack_public_path__ + "assets/icon-permanentPosts-metalPermanent.4bea2380.svg";